import AnimatedLink from "@components/animated-link";
import Searchbar from "@components/searchbar";
import { useSearchStore } from "@state/search-store";
import * as React from "react";

import routes from "../NavigatorRoutes";
import { View } from "dripsy";
import { Platform, Pressable } from "react-native";
import { useNavigation } from "react-native-ridge-navigation";

export let autoFocusSearchbar = false;

function useClearSearchWhenStoppingWithSearching({ isButton }: { isButton: boolean }) {
  const { search } = useSearchStore();
  React.useEffect(() => {
    if (!isButton) {
      return () => {
        search("");
      };
    }
  }, [isButton]);
}

function useDisableAutoFocusForNextRender() {
  React.useEffect(() => {
    autoFocusSearchbar = false;
  }, []);
}

export default function ProductSearchbar({
  placeholder,
  isButton,
  isPop,
}: {
  placeholder: string;
  isButton: boolean;
  isPop?: boolean;
}) {
  const { pop } = useNavigation();
  const { search, searchQuery } = useSearchStore();
  useDisableAutoFocusForNextRender();
  useClearSearchWhenStoppingWithSearching({ isButton });
  const noPointerEventsProps =
    Platform.OS === "web" ? { sx: { pointerEvents: "none" } as any } : { pointerEvents: "none" as const };

  const inner = (
    <Searchbar placeholder={placeholder} search={search} searchQuery={searchQuery} autoFocus={autoFocusSearchbar} />
  );
  if (isPop) {
    return (
      <Pressable
        onPress={() => {
          pop();
        }}
        onPressIn={() => {
          autoFocusSearchbar = true;
        }}
      >
        <View {...noPointerEventsProps}>{inner}</View>
      </Pressable>
    );
  } else if (isButton) {
    return (
      <AnimatedLink
        to={routes.SearchScreen}
        params={{}}
        onPressIn={() => {
          autoFocusSearchbar = true;
        }}
      >
        <View {...noPointerEventsProps}>{inner}</View>
      </AnimatedLink>
    );
  }
  return inner;
}
